// src/store/rtkQueryErrorLogger.js

import { isRejectedWithValue } from "@reduxjs/toolkit";
import { addNotification } from "./notificationSlice";

/**
 * Middleware de Redux que intercepta acciones asíncronas fallidas (thunks)
 * y despacha una notificación de error estandarizada.
 */
export const rtkQueryErrorLogger = (api) => (next) => (action) => {
  // Verificamos si la acción es un "thunk" que ha sido rechazado.
  if (isRejectedWithValue(action)) {
    // Extraemos el mensaje de error del payload.
    // Puede ser una cadena o un objeto con una propiedad 'message'.
    const errorMessage =
      action.payload?.message ||
      action.payload ||
      "Ocurrió un error inesperado.";

    // Despachamos nuestra acción para mostrar la notificación de error.
    api.dispatch(
      addNotification({
        type: "error",
        message: errorMessage,
        isPersistent: true, // Los errores importantes deben ser cerrados manualmente.
      })
    );
  }

  return next(action);
};
